/* Etiquetas multiidoma en castellano. */
export default {
  "codename.clean": "limpiar",
};
